import React from "react";

const ErrorDiv = ({children}) =>
{
    const style = {marginTop: '5px', color: 'red'};

    return <div style={style}>{children}</div>
}

export { ErrorDiv } ;